import VueRouter from 'vue-router'
import home from '_v/home'
import { unlogin } from '_s/service/api/login.js';

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: () => import('_v/login'),
    },
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      component: home,
    },
    {
      path: '/effect',
      component: () => import('_v/effect'),
    },
    {
      path: '/duty',
      component: () => import('_v/duty'),
    },
    {
      path: '/policy',
      component: () => import('_v/policy'),
    },
    {
      path: '/work',
      component: () => import('_v/work'),
    },
  ],
})

// 路由反复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach((to, from, next) => {
  let arr = to.query
  if (arr.uname && arr.pword) {
    const param = {
      username: arr.uname.replace(/ /g, '+'),
      password: arr.pword.replace(/ /g, '+'),
    }
    unlogin(param).then((res) => {
      if (res.success) {
        sessionStorage.setItem('token', res.result.token)
        let areacode = res.result.userInfo.areacode
        if (areacode) {
          sessionStorage.setItem('areacode', areacode.split(',')[0])
          sessionStorage.setItem('multiareacode', areacode)
          sessionStorage.setItem('tenantId', res.result.userInfo.tenantId)
        }
        if (res.result.token) {
          return next('/effect')
        }
      }
    })
  }

  // 路由守卫
  const token = sessionStorage.getItem('token')
  // token存在就进入后台给的路由地址进行跳转

  // 1.如果访问的是登录页面（无需权限），直接放行
  if (to.path === '/login') {
    if (token) {
      // if (maptoken) {
      //   return next('/shareMap');
      // } else {
      // 2.如果访问的是登录页面，但是已经登录过了，直接跳转到首页
      return next('/')
      // }
    } else {
      // 3.如果访问的是登录页面，但是没有登录过，直接放行
      return next()
    }
  }

  // 4.如果token为空，强制跳转到登录页面；否则，直接放行
  if (!token) {
    return next('/login')
  }

  next()
})

export default router
